<template>
<div class="LoginFormPatient">
  
  <a-form
    ref="form"
    :model="formState"
    :rules="formRules"
    layout="vertical"
    validateTrigger="onSubmit"
    :hideRequiredMark="true"
    @finish="onSubmit"
  >
  
    <a-form-item
      class="ant-form-item-primary"
      name="form_name"
      :label="formSetup.name.label"
    >
      <a-input
        v-model:value="form_name"
        :disabled="loading"
        @change="onChange"
        size="large"
      />
    </a-form-item>
    
    <a-form-item
      class="ant-form-item-primary"
      name="form_dob"
      :label="formSetup.dob.label"
    >
      <a-input
          v-model:value="form_dob"
          :disabled="loading"
          @change="onChangeDob"
          size="large"
      />
<!--      <a-date-picker
        class="LoginFormPatient__date"
        v-model:value="form_dob"
        :valueFormat="`YYYY-MM-DD[T]HH:mm:ss.000000[Z]`"
        :disabled-date="disabledDate"
        :disabled="loading"
        @change="onChange"
        size="large"
      />-->
    </a-form-item>
    
    <a-form-item
      class="ant-form-item-primary"
      name="form_email"
      :label="formSetup.email.label"
    >
      <a-input
        v-model:value="form_email"
        :disabled="loading"
        @change="onChange"
        size="large"
      />
    </a-form-item>
    
    <a-form-item
      class="ant-form-item-primary"
      name="form_sex"
      :label="formSetup.sex.label"
    >
      <a-select
        v-model:value="form_sex"
        :options="sex"
        :disabled="loading"
        @change="onChange"
        size="large"
      />
    </a-form-item>
    
    <a-button
      class="ant-btn-huge LoginFormPatient__submit"
      type="green"
      size="large"
      html-type="submit"
      :loading="loading"
    >
      Next
    </a-button>
    
  </a-form>
  
</div>
</template>

<script>
import { isSuccess } from '@/helpers/http.helper'
import { mapFields } from '@/helpers/form.helper'
import { mapMutations, mapGetters, mapActions } from "vuex"
import { toast } from '@/helpers/error.helper'
import sex from '@/vocabulary/sex.options.json'
import IMask from 'imask'

let serverErr, formSetup = {
  name: {
    label: 'Patient name',
    rules: [
      { required: true, message: 'Please enter name' },
      { validator: async () => Promise[serverErr?.name?.length ? 'reject' : 'resolve'](serverErr?.name?.[0]) },
    ]
  },
  dob: {
    label: 'Date of birth',
    rules: [
      { required: true, message: 'Please enter date of birth' },
      { validator: async () => Promise[serverErr?.dob?.length ? 'reject' : 'resolve'](serverErr?.dob?.[0]) },
    ]
  },
  email: {
    label: 'E-mail',
    rules: [
      { required: true, message: 'Please enter e-mail' },
      { type: 'email', message: 'Invalid e-mail address' },
      { validator: async () => Promise[serverErr?.email?.length ? 'reject' : 'resolve'](serverErr?.email?.[0]) },
    ]
  },
  sex: {
    label: 'Sex',
    rules: [
      { required: true, message: 'Please enter sex' },
      { validator: async () => Promise[serverErr?.sex?.length ? 'reject' : 'resolve'](serverErr?.sex?.[0]) },
    ]
  },
}

export default {
  name: "LoginFormPatient",
  data() {
    return {
      loading: false,
      formSetup,
      sex,
    }
  },
  computed: {
    ...mapGetters({
      patient: 'PatientPatientStore/getPatient',
    }),
    ...mapFields({
      formSetup,
      props: ['fields', 'formState', 'formRules'],
      getter: (vm, field) => vm.patient[field],
      setter: (vm, field, value) => vm.setPatientField({ field, value}),
    }),
    dobMask() {
      return IMask.createMask({
        mask: '0000-00-00', // 0000-00-00
        definitions: {
          '#': /[a-zA-Z]/
        }
      })
    },
  },
  mounted(){
    if (this.form_dob) this.onChangeDob() 
  },
  methods: {
    ...mapActions({
      updatePatient: 'PatientPatientStore/update',
    }),
    ...mapMutations({
      setPatient: 'PatientPatientStore/setPatient',
      setPatientField: 'PatientPatientStore/setPatientField',
    }),
    disabledDate(current) {
      return current && current > $moment()
    },
    onChange() {
      this.$refs.form.clearValidate()
      serverErr = null
    },
    onChangeDob() {
      this.onChange()
      this.dobMask.resolve(this.form_dob)
      this.form_dob = this.dobMask.value.toUpperCase()
    },
    async onSubmit() {
      let payload = this.patient.toApi()
      this.loading = true
      await this.updatePatient({ payload })
        .then((response) => {
          if (response instanceof Error || !isSuccess(response.status)) throw response
          toast ({ type: 'success', msg: 'Success' })
          this.setPatient(this.patient)
          this.$router.push({ name: 'patient.auth.notify' })
        })
        .catch((err) => {
          serverErr = err.response?.data?.errors
          toast ({ msg: err?.data?.data?.message })
          this.$refs.form.validateFields()
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.LoginFormPatient {
  padding: 24px 0;
  
  &__date {
    width: 100%;
  }
  
  &__submit {
    margin-top: 10px;
  }
  
}
</style>